import { useSelector } from "react-redux";

import { IAppState } from "../store/Root";

const useAuth = () => useSelector(({ auth }: IAppState) => auth);

export default useAuth;
